import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const LOGGED_IN_AS_BANNER_CLASS_NAME = 'LoggedInAsBanner';
export const LOGGED_IN_AS_BANNER_CLASS_SLOTS = ['root'] as const;

export type LoggedInAsBannerClassSlot =
	(typeof LOGGED_IN_AS_BANNER_CLASS_SLOTS)[number];

export interface LoggedInAsBannerClasses {
	root: string;
	details: string;
	detailsWrapper: string;
}

export type LoggedInAsBannerClassKey = keyof LoggedInAsBannerClasses;

export const getLoggedInAsBannerUtilityClass = (slot: string) =>
	generateUtilityClass(LOGGED_IN_AS_BANNER_CLASS_NAME, slot);

export const loggedInAsBannerClasses = generateUtilityClasses<
	keyof LoggedInAsBannerClasses
>(LOGGED_IN_AS_BANNER_CLASS_NAME, ['root']);

export default loggedInAsBannerClasses;
